import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';
import { P } from 'common/ui/Text';
import styles from 'css-module/components/subdomain/admin/reports/_EmptyState.module.scss';

import NoDataIcon from 'img/icons/no-data.svg';

type Props = {
  title?: string | null;
  icon?: string | null;
  message: string;
  learnMore?: string;
};

const EmptyState = ({
  title = 'No results found',
  icon = NoDataIcon,
  message,
  learnMore,
}: Props) => {
  return (
    <div className={styles.emptyState}>
      {icon ? <LazyLoadedImage className={styles.emptyStateIcon} src={icon} /> : null}
      {title ? <P fontWeight="semibold">{title}</P> : null}
      <div>
        <P>{message}</P>
        {learnMore ? (
          <P>
            <a href={learnMore} className={styles.learnMore}>
              Learn more
            </a>
          </P>
        ) : null}
      </div>
    </div>
  );
};

export default EmptyState;
